// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import { isMobileOnly } from 'react-device-detect';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Styling
import './checkout.scss';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { COMPANY_DATA, FORM_FIELD_QUALIFICATION_NON_EU_BALLOT_NUMBER, PAYMENT_METHOD_CC, PAYMENT_METHOD_MB, PAYMENT_METHOD_MBWAY, PERSONAL_COMPANY_DATA, PERSONAL_DATA } from '../../common/constants';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { WORLD_LIST } from '../../common/lists/countries';
import { Button } from 'primereact/button';
import { validateNIF } from '../../common/utils/validation-utils';
import StoreService from '../../redux/services/store';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import { updateBasket, updateOrderOperationData, updatePublicBuyer } from '../../redux/actions/order';
import { getCreditCardFormConfig } from '../../common/utils/credit-card-utils';
import FinancialService from '../../redux/services/finance';
import { updateGeneratedPaymentRef } from '../../redux/actions/quote';
import { getPrettyDate } from '../../common/utils/date-utils';

class CheckoutPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            showPaymentData: false,
            // Invoice data management
            mobilePhoneNumber: "",
            mobilePhoneNumberPrefix: "351",
            mbEntity: "",
            mbReference: "",
            mbValue: "",
            mbDueDate: "",
            showCardForm: false,
            showConfirmationMessage: false,
            serverLoading: false,
            free:false,
            // Validation flags
            validMobilePhoneNumberPrefix: true,
            validMobilePhoneNumber: true,
            validCompanyEntity: true,
            validCompanyNipc: true,
            validPaymentMethod: true
        };
    }

    componentDidMount() {
        // Check if the page was called from SIBS
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let formIdParam = params.get('id');

        if(formIdParam !== null) {
            FinancialService.getCreditCardCheckoutStatus(formIdParam)
            .then((response) => {
                let successCodesRegex = new RegExp('^(000\.000\.|000\.100\.1|000\.[36])');

                // Confirm if payment was successful
                if(successCodesRegex.test(response.checkout.result.code)) {
                    this.submitOrder();
                }
                else {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.credit-card-error"), life: 5000 });
                }
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.error"), life: 3000 });
            });

            this.setState({
                showCardForm: false
            });
        }
        else {
            this.setState({
                showConfirmationMessage: false
            });

            this.props.updateOrderOperationData({
                selectedPaymentMethod: null,
                entity: null,
                nIPC: null,
                nIPCCountry: null,
                selectedInvoiceData: PERSONAL_DATA
            });
        }
    }

    updateInvoiceData(invoiceData) {
        this.setState({
            selectedInvoiceData: invoiceData
        });
        this.props.updateOrderOperationData({
            entity: this.props.operation.entity,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
            selectedInvoiceData: invoiceData
        });
    }

    updatePaymentMethod(paymentMethod) {
        this.props.updateOrderOperationData({
            entity: this.props.operation.entity,
            nIPC: this.props.operation.nIPC,
            nIPCCountry: this.props.operation.nIPCCountry,
            selectedPaymentMethod: paymentMethod,
            selectedInvoiceData: this.props.operation.selectedInvoiceData
        });
    }

    updateCompanyInvoiceData(column, value) {
        if(column === "companyEntity") {
            this.props.updateOrderOperationData({
                entity: value,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }

        if(column === "companyNipc") {
            this.props.updateOrderOperationData({
                entity: this.props.operation.entity,
                nIPC: value,
                nIPCCountry: this.props.operation.nIPCCountry,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }

        if(column === "companyNipcCountry") {
            this.props.updateOrderOperationData({
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: value,
                selectedPaymentMethod: this.props.operation.selectedPaymentMethod,
                selectedInvoiceData: this.props.operation.selectedInvoiceData
            });
        }
    }

    amountBodyTemplate(rowData) {
        if(rowData.price === null) {
            return "Gratuito";
        }
        else {
            if(rowData.price.toString().includes(".")) {
                let amountParts = rowData.price.toString().split(".");

                if(amountParts[1].length === 1) {
                    return rowData.price + "0 €";
                }
                else {
                    return rowData.price + " €";
                }     
            }
            else {
                return rowData.price + ".00 €";
            }
        }

        return "";
    }

    actionsProductsBodyTemplate(rowData) {
        return <Button icon="pi pi-trash" tooltip={this.props.t("checkout.form.remove-product")} iconPos="right" onClick={() => this.removeProductFromBasket(rowData.productRef)}/>;
    }

    actionsTrainingsBodyTemplate(rowData) {
        return <Button icon="pi pi-trash" tooltip={this.props.t("checkout.form.remove-product")} iconPos="right" onClick={() => this.removeTrainingFromBasket(rowData.trainingRef)}/>;
    }

    removeProductFromBasket(reference) {
        let products = this.props.basketProducts;

        let updatedProducts = [];

        for (let i = 0; i < products.length; i++) {
            if(products[i].productRef !== reference) {
                updatedProducts.push(products[i]);
            }
        }
        this.props.updateBasket(updatedProducts, this.props.basketTrainings);
    }

    removeTrainingFromBasket(reference) {
        let trainings = this.props.basketTrainings;

        let updatedTrainings = [];

        for (let i = 0; i < trainings.length; i++) {
            if(trainings[i].trainingRef !== reference) {
                updatedTrainings.push(trainings[i]);
            }
        }

        this.props.updateBasket(this.props.basketProducts, updatedTrainings);
    }

    getBasketTotal() {
        let price = null;

        for (let i = 0; i < this.props.basketProducts.length; i++) {
            if(price === null) {
                price = this.props.basketProducts[i].price;    
            } 
            else {
                price += this.props.basketProducts[i].price;            
            }
        }

        for (let i = 0; i < this.props.basketTrainings.length; i++) {
            if(price === null) {
                price = this.props.basketTrainings[i].price;    
            } 
            else {
                price += this.props.basketTrainings[i].price;            
            }
        }

        return price;
    }

    validateForm() {
        let validPaymentMethod = (this.props.operation.selectedPaymentMethod !== null);
        let validEntity = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
        let validNipc = (this.props.operation.selectedInvoiceData === PERSONAL_DATA);
        let validMobilePhoneNumber = true;
        let validMobilePhoneNumberPrefix = true;

        this.setState({
            validPaymentMethod: validPaymentMethod
        });

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            validEntity = (this.props.operation.entity !== null && this.props.operation.entity !== "");
            validNipc = (this.props.operation.nIPC !== null && this.props.operation.nIPC !== "") && validateNIF(this.props.operation.nIPC);

            this.setState({
                validCompanyEntity: validEntity,
                validCompanyNipc: validNipc
            });
        }

        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
            validMobilePhoneNumber = (this.state.mobilePhoneNumber !== null && this.state.mobilePhoneNumber !== "");

            if(validMobilePhoneNumber) {
                if(this.state.mobilePhoneNumber.slice(0, 3) === "351") {
                    validMobilePhoneNumber = (this.state.mobilePhoneNumber.length === 12);
                }
            }
            
            validMobilePhoneNumberPrefix = this.state.mobilePhoneNumberPrefix !== "";

            this.setState({
                validMobilePhoneNumber: validMobilePhoneNumber,
                validMobilePhoneNumberPrefix: validMobilePhoneNumberPrefix
            });
        }

        return validPaymentMethod && validEntity && validNipc && validMobilePhoneNumber && validMobilePhoneNumberPrefix;
    }

    submitOrder() {

        this.setState({
            free: this.getBasketTotal() === null
        });     

        let orderRequest = {
            associateId: this.props.publicBuyer === null ? this.props.associate.associateId : this.props.publicBuyer.associateId,
            buyer: this.props.publicBuyer === null ? null : (this.props.publicBuyer.associateId !== null && this.props.publicBuyer.associateId !== undefined) ? null : this.props.publicBuyer,
            paymentChannel: this.getBasketTotal() !== null ? this.props.operation.selectedPaymentMethod : PAYMENT_METHOD_MB,
            mobilePhoneNumber: this.state.mobilePhoneNumberPrefix + "#" + this.state.mobilePhoneNumber,
            company: null,
            products: this.props.basketProducts,
            trainings: this.props.basketTrainings
        };

        if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC)
        {
            orderRequest.paymentRef = this.props.generatedPaymentRef;
        }

        if(this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA) {
            orderRequest.company = {
                entity: this.props.operation.entity,
                nIPC: this.props.operation.nIPC,
                nIPCCountry: this.props.operation.nIPCCountry.code
            };
        }

        if(this.getBasketTotal() === null || this.validateForm()) {
            this.setState({
                serverLoading: true
            });

            StoreService.submitOrder(orderRequest)
            .then((response) => {
                this.setState({
                    serverLoading: false,
                    showConfirmationMessage: true,
                    mbEntity: response.mbEntity,
                    mbReference: response.mbReference,
                    mbValue: this.amountBodyTemplate({ price: response.amount }),
                    mbDueDate: getPrettyDate(response.dueDate)
                });

                this.props.updatePublicBuyer(null);
                this.props.updateBasket([], []);
            })
            .catch(error => {
                this.setState({
                    serverLoading: false
                });

                if(this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY) {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.mbway-error"), life: 5000 });
                }
                else {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.error"), life: 3000 });
                }
            });
        }
    }

    generateCreditCardCheckout() {
        StoreService.generateCreditCardCheckout({
            products: this.props.basketProducts,
            trainings: [],
            email: this.props.associate.personalData.email
        })
        .then((response) => {
            const script1 = document.createElement("script");
            script1.innerHTML = getCreditCardFormConfig(this.props.associate.personalData.city,
                this.props.associate.personalData.cP4,
                this.props.associate.personalData.cP3,
                this.props.associate.personalData.addressLine1,
                this.props.associate.personalData.addressLine2,
                this.props.t("checkout.messages.invalid-holder"));
            script1.async = true;
            
            const script2 = document.createElement("script");
            script2.src = process.env.REACT_APP_SIBS_WIDGET_URL + response.checkout.id;
            script2.async = true;

            document.body.appendChild(script1);
            document.body.appendChild(script2);

            this.setState({
                showCardForm: true
            });

            this.props.updateGeneratedPaymentRef(response.paymentRef);
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.error"), life: 3000 });
        });
    }


    render() {
       return (
            <div>
                <PageTitleComponent title={this.props.t("checkout.title")} />
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-2'></div>
                    <div className="col-8"> 
                    { this.state.serverLoading ? 
                        <div className='container'>
                            <div className="col-12 t-align-center">
                                <i className="mgt-100 mgb-100 pi pi-spin pi-spinner" style={{ fontSize: '4rem', color: '#0073aa' }}></i>
                            </div>
                        </div>
                        : 
                        <div className='card grid mgt-20'>
                            <div className='col-12'>
                                {
                                    this.state.free ?
                                            <div className="col-12 t-align-center mgt-20">
                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                {
                                                    this.props.basketProducts.length > 0 ?
                                                        <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-payment")}</span>
                                                        :
                                                        <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-registration")}</span>                                                
                                                }
                                            </div> 
                                        : null
                                }
                                {
                                    this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB && (this.state.mbEntity === "" || this.state.mbEntity === null) && this.state.showConfirmationMessage === true ?
                                            <div className="col-12 t-align-center mgt-20">
                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-payment")}</span>
                                            </div> 
                                        : null
                                }
                                {
                                    this.state.showConfirmationMessage === true && this.state.mbEntity !== "" && this.state.mbEntity !== null && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB ?
                                        <>
                                            <div className="col-12 t-align-center mgt-20">
                                                <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                                <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-mb")}</span>
                                            </div> 
                                            <div className="col-12 t-align-left mgt-20">
                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.entity")} </b>{this.state.mbEntity}</p>
                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.reference")} </b>{this.state.mbReference}</p>
                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.value")} </b>{this.state.mbValue}</p>
                                                <p style={{fontSize:'13px'}}><b>{this.props.t("quotes.dialog.mb.due-date")} </b>{this.state.mbDueDate}</p>
                                            </div>   
                                        </>
                                        : null
                                }
                                {
                                    this.state.showConfirmationMessage === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ?
                                
                                        <div className="col-12 t-align-center mgt-20">
                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                            <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-payment")}</span>
                                        </div>   
                                        : null
                                }
                                {
                                    this.state.showConfirmationMessage === true && this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                
                                        <div className="col-12 t-align-center mgt-20">
                                            <p><i className="pi pi-check-circle" style={{ fontSize: '2rem', color:'green' }}></i></p>
                                            <span style={{fontSize:'15px'}}>{this.props.t("checkout.messages.success-mb-way")}</span>
                                        </div>   
                                        : null
                                }
                                {
                                    !this.state.showConfirmationMessage ?
                                    <>
                                    {
                                        this.props.basketProducts.length === 0 && this.props.basketTrainings.length === 0 ?
                                            <div className="col-12">
                                                <DataTable value={this.props.basketProducts} className="p-datatable-gridlines" showGridlines rows={12} dataKey="productRef" responsiveLayout="scroll" emptyMessage={this.props.t("checkout.messages.no-products")}>
                                                    <Column field="title" header={this.props.t("checkout.form.title-header")} />
                                                    <Column field="price" header={this.props.t("checkout.form.amount-header")} style={{ minWidth: '50px' }} body={(data) => this.amountBodyTemplate(data)}  />
                                                    <Column field="productId" header={this.props.t("checkout.form.actions-header")} style={{ maxWidth: '15px' }} body={(data) => this.actionsProductsBodyTemplate(data)} />
                                                </DataTable>
                                            </div>
                                            : null
                                    }
                                    {
                                        this.props.basketProducts.length !== 0 ?
                                            <>
                                                {
                                                    this.props.basketTrainings.length !== 0 ?
                                                        <div className="col-12 t-align-left">
                                                            <p style={{marginBottom:"5px", fontWeight:"bold", fontSize:"14px"}}>{this.props.t("checkout.form.products")} </p>
                                                        </div>
                                                        : null
                                                }
                                                <div className="col-12">
                                                    <DataTable value={this.props.basketProducts} className="p-datatable-gridlines" showGridlines rows={12} dataKey="productRef" responsiveLayout="scroll" emptyMessage={this.props.t("checkout.messages.no-products")}>
                                                        <Column field="title" header={this.props.t("checkout.form.title-header")} />
                                                        <Column field="price" header={this.props.t("checkout.form.amount-header")} style={{ minWidth: '50px' }} body={(data) => this.amountBodyTemplate(data)}  />
                                                        <Column field="productId" header={this.props.t("checkout.form.actions-header")} style={{ maxWidth: '15px' }} body={(data) => this.actionsProductsBodyTemplate(data)} />
                                                    </DataTable>
                                                </div>
                                            </>
                                            : null
                                    }
                                    {
                                        this.props.basketTrainings.length !== 0 ?
                                            <>
                                                {
                                                    this.props.basketProducts.length !== 0 ?
                                                        <div className="col-12 t-align-left">
                                                            <p style={{marginTop: "10px", marginBottom:"5px", fontWeight:"bold", fontSize:"14px"}}>{this.props.t("checkout.form.trainings")} </p>
                                                        </div>
                                                        : null
                                                }
                                                <div className="col-12">
                                                    <DataTable value={this.props.basketTrainings} className="p-datatable-gridlines" showGridlines rows={12} dataKey="trainingRef" responsiveLayout="scroll" emptyMessage={this.props.t("checkout.messages.no-products")}>
                                                        <Column field="title" header={this.props.t("checkout.form.training-header")} />
                                                        <Column field="price" header={this.props.t("checkout.form.amount-header")} style={{ minWidth: '50px' }} body={(data) => this.amountBodyTemplate(data)}  />
                                                        <Column field="trainingId" header={this.props.t("checkout.form.actions-header")} style={{ maxWidth: '15px' }} body={(data) => this.actionsTrainingsBodyTemplate(data)} />
                                                    </DataTable>
                                                </div>
                                            </>
                                            : null
                                    }
                                    {
                                        this.getBasketTotal() !== null ?
                                            <div className="col-12 t-align-right">
                                                <p style={{fontSize:'13px', fontWeight:'bold'}}>{this.props.t("checkout.form.total")} {this.amountBodyTemplate({ price: this.getBasketTotal() }) }</p>
                                            </div>
                                            : null
                                    }

                                    {
                                        this.getBasketTotal() !== null ?
                                        <>
                                            <div className='grid'>
                                                {
                                                    !this.state.showPaymentData ?
                                                        <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                            {/*
                                                                this.props.userId === null ? 
                                                                    <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.open(process.env.PUBLIC_URL + "/products-public", "_self")} />
                                                                    : 
                                                                    <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                            */}
                                                            <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                            <Button className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}} onClick={() => this.setState({ showPaymentData: true })} label={this.props.t("checkout.messages.go-to-payment")} />
                                                        </div> 
                                                        :
                                                        <>
                                                            <div className='col-12 t-align-left mgt-20'><b>{this.props.t("checkout.form.payment-data")}</b></div>
                                                            <div className='col-12 lg:col-3'>
                                                                <div>
                                                                    <div className="field-radiobutton">
                                                                        <RadioButton inputId="ref-mb" name="payment-method" value={PAYMENT_METHOD_MB} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MB)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MB} />
                                                                        <label htmlFor="ref-mb">{this.props.t("quotes.dialog.payment-methods.mb")}</label>
                                                                    </div>
                                                                    <div className="field-radiobutton">
                                                                        <RadioButton inputId="cc" name="payment-method" value={PAYMENT_METHOD_CC} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_CC)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC} />
                                                                        <label htmlFor="cc">{this.props.t("quotes.dialog.payment-methods.cc")}</label>
                                                                    </div>
                                                                    <div className="field-radiobutton">
                                                                        <RadioButton inputId="mb-way" name="payment-method" value={PAYMENT_METHOD_MBWAY} onChange={(e) => this.updatePaymentMethod(PAYMENT_METHOD_MBWAY)} checked={this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY} />
                                                                        <label htmlFor="mb-way">{this.props.t("quotes.dialog.payment-methods.mbway")}</label>
                                                                    </div>
                                                                </div>
                                                                { this.state.validPaymentMethod ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                            </div>
                                                        </>
                                                }
                                                {
                                                    isMobileOnly ? 
                                                    <div className='col-12 t-align-left'>
                                                    {
                                                        this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                            <div className='grid'>
                                                                <div className='col-12 t-align-left'>
                                                                    <p>{this.props.t("quotes.dialog.mbway")}</p>
                                                                </div> 
                                                                <div className='col-12 t-align-left'>
                                                                    <label className='mgr-10' htmlFor="mobile-number-prefix">{this.props.t("quotes.dialog.mobile-number-prefix")}</label>
                                                                    <InputText autocomplete="off" value={this.state.mobilePhoneNumberPrefix} className={!this.state.validMobilePhoneNumberPrefix ? "p-invalid" : null} id="mobile-number-prefix" type="number" style={{width:"80px"}} onChange={(evt) => this.setState({mobilePhoneNumberPrefix: evt.target.value})} />
                                                                    { this.state.validMobilePhoneNumberPrefix ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                </div> 
                                                                <div className='col-12 t-align-left'>
                                                                    <label className='mgr-10' htmlFor="mobile-number">{this.props.t("quotes.dialog.mobile-number")}</label>
                                                                    <InputText autocomplete="off" value={this.state.mobilePhoneNumber} className={!this.state.validMobilePhoneNumber ? "p-invalid" : null} id="mobile-number" type="number" onChange={(evt) => this.setState({mobilePhoneNumber: evt.target.value})} />
                                                                    { this.state.validMobilePhoneNumber ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                </div> 
                                                            </div>
                                                            : <div className='col-12 t-align-left'></div>
                                                    }
                                                    </div>
                                                    :
                                                    <div className='col-9 t-align-left'>
                                                    {
                                                        this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_MBWAY ?
                                                            <div className='grid'>
                                                                <div className='col-12 t-align-left'>
                                                                    <p>{this.props.t("quotes.dialog.mbway")}</p>
                                                                </div> 
                                                                <div className='col-4 t-align-left'>
                                                                    <label className='mgr-10' htmlFor="mobile-number-prefix">{this.props.t("quotes.dialog.mobile-number-prefix")}</label>
                                                                    <InputText autocomplete="off" value={this.state.mobilePhoneNumberPrefix} className={!this.state.validMobilePhoneNumberPrefix ? "p-invalid" : null} id="mobile-number-prefix" type="number" style={{width:"80px"}} onChange={(evt) => this.setState({mobilePhoneNumberPrefix: evt.target.value})} />
                                                                    { this.state.validMobilePhoneNumberPrefix ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                </div> 
                                                                <div className='col-8 t-align-left'>
                                                                    <label className='mgr-10' htmlFor="mobile-number">{this.props.t("quotes.dialog.mobile-number")}</label>
                                                                    <InputText autocomplete="off" value={this.state.mobilePhoneNumber} className={!this.state.validMobilePhoneNumber ? "p-invalid" : null} id="mobile-number" type="number" onChange={(evt) => this.setState({mobilePhoneNumber: evt.target.value})} />
                                                                    { this.state.validMobilePhoneNumber ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                </div> 
                                                            </div>
                                                            : <div className='col-12 t-align-left'></div>
                                                    }
                                                    </div>
                                                }
                                            </div>
                                            <div className='grid mgt-10'>
                                                {
                                                    this.state.showPaymentData && (this.props.publicBuyer === undefined || this.props.publicBuyer === null) ?
                                                        <div className='col-12 t-align-left mgt-10'>
                                                            <b className='mgb-20'>{this.props.t("quotes.dialog.invoice-data")}</b>
                                                            <div className="field-radiobutton mgt-10">
                                                                <RadioButton inputId="personal-data" name="invoice-data" value={PERSONAL_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_DATA} />
                                                                <label htmlFor="personal-data">{this.props.t("quotes.dialog.my-invoice-data")}<b>{this.props.t("quotes.dialog.name-nif").replace("{0}", this.props.associate.personalData.name).replace("{1}", this.props.associate.personalData.nif)}</b></label>
                                                            </div>
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="company-data" name="invoice-data" value={PERSONAL_COMPANY_DATA} onChange={(e) => this.updateInvoiceData(PERSONAL_COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA} />
                                                                <label htmlFor="company-data">{this.props.t("quotes.dialog.personal-company-invoice-data")}</label>
                                                            </div>
                                                            <div className="field-radiobutton">
                                                                <RadioButton inputId="company-data" name="invoice-data" value={COMPANY_DATA} onChange={(e) => this.updateInvoiceData(COMPANY_DATA)} checked={this.props.operation.selectedInvoiceData === COMPANY_DATA} />
                                                                <label htmlFor="company-data">{this.props.t("quotes.dialog.other-company-invoice-data")}</label>
                                                            </div>
                                                        </div> 
                                                        : null
                                                }
                                                {
                                                    this.props.operation.selectedInvoiceData === PERSONAL_COMPANY_DATA || this.props.operation.selectedInvoiceData === COMPANY_DATA ?
                                                        <>
                                                            {
                                                                isMobileOnly ?
                                                                    <>
                                                                        <div className='col-12 t-align-left'>
                                                                            <label  htmlFor="company-entity">{this.props.t("quotes.dialog.company-entity")}</label>
                                                                            <InputText value={this.props.operation.entity} className={!this.state.validCompanyEntity ? "p-invalid" : null} id="company-entity" style={{marginLeft:"10px"}} type="text" onChange={(evt) => this.updateCompanyInvoiceData("companyEntity", evt.target.value) } />
                                                                            { this.state.validCompanyEntity ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                        </div>
                                                                        <div className='col-12 t-align-left'> 
                                                                            <label htmlFor="company-nipc">{this.props.t("quotes.dialog.company-nipc")}</label>
                                                                            <InputText value={this.props.operation.nIPC} className={!this.state.validCompanyNipc ? "p-invalid" : null} id="company-nipc" type="text" style={{marginLeft:"10px"}} onChange={(evt) => this.updateCompanyInvoiceData("companyNipc", evt.target.value) } />
                                                                            { this.state.validCompanyNipc ? null : <p><small className="p-error">{this.props.t("quotes.messages.invalid-nif")}</small></p>  }
                                                                        </div> 
                                                                        <div className='col-12 t-align-left'>
                                                                            <label htmlFor="nipc-country">{this.props.t("quotes.dialog.company-nipc-country")}</label>
                                                                            <Dropdown id="nipc-country" style={{marginLeft:"10px"}} value={this.props.operation.nIPCCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateCompanyInvoiceData("companyNipcCountry", evt.value) }></Dropdown>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className='col-6 t-align-left'>
                                                                            <label  htmlFor="company-entity">{this.props.t("quotes.dialog.company-entity")}</label>
                                                                            <InputText value={this.props.operation.entity} className={!this.state.validCompanyEntity ? "p-invalid" : null} id="company-entity" style={{width: "350px", marginLeft:"10px"}} type="text" onChange={(evt) => this.updateCompanyInvoiceData("companyEntity", evt.target.value) } />
                                                                            { this.state.validCompanyEntity ? null : <p><small className="p-error">{this.props.t("general.mandatory-field")}</small></p>  }
                                                                        </div>
                                                                        <div className='col-3 t-align-left'> 
                                                                            <label htmlFor="company-nipc">{this.props.t("quotes.dialog.company-nipc")}</label>
                                                                            <InputText value={this.props.operation.nIPC} className={!this.state.validCompanyNipc ? "p-invalid" : null} id="company-nipc" type="text" style={{width:"100px", marginLeft:"10px"}} onChange={(evt) => this.updateCompanyInvoiceData("companyNipc", evt.target.value) } />
                                                                            { this.state.validCompanyNipc ? null : <p><small className="p-error">{this.props.t("quotes.messages.invalid-nif")}</small></p>  }
                                                                        </div> 
                                                                        <div className='col-3 t-align-left'>
                                                                            <label htmlFor="nipc-country">{this.props.t("quotes.dialog.company-nipc-country")}</label>
                                                                            <Dropdown id="nipc-country" style={{width:"150px", marginLeft:"10px"}} value={this.props.operation.nIPCCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateCompanyInvoiceData("companyNipcCountry", evt.value) }></Dropdown>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </>
                                                        : null
                                                } 
                                                {
                                                    this.state.showCardForm ? 
                                                        <div className="col-12 t-align-left mgt-10">
                                                            <form action={process.env.REACT_APP_BASE_ADDRESS + "/checkout"} className="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                                        </div> 
                                                    : null
                                                }
                                                </div>
                                            </>
                                            : null
                                    }
                                    {
                                        (this.props.basketProducts.length > 0 || this.props.basketTrainings.length > 0) && this.getBasketTotal() === null ?
                                            <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                {/*
                                                    this.props.userId === null && this.props.basketProducts.length > 0 ?
                                                        <>
                                                            <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.open(process.env.PUBLIC_URL + "/products-public", "_self")} />
                                                            <Button className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}} label={this.getBasketTotal() !== null ? this.props.t("quotes.dialog.confirm") : this.props.t("checkout.messages.confirm")} onClick={() => this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ? this.generateCreditCardCheckout() : this.submitOrder()} />
                                                        </>
                                                        : null
                                                */}
                                                {
                                                    //this.props.userId !== null && this.props.basketProducts.length > 0 ?
                                                        <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                      //  :
                                                        //<Button className='p-button-info' label={this.props.t("checkout.messages.continue-training")} onClick={() => window.open(process.env.PUBLIC_URL + "/trainings", "_self")} />
                                                }
                                                {
                                                    this.props.userId !== null && this.props.basketProducts.length > 0 ?
                                                        <Button className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}} label={this.getBasketTotal() !== null ? this.props.t("quotes.dialog.confirm") : this.props.t("checkout.messages.confirm")} onClick={() => this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ? this.generateCreditCardCheckout() : this.submitOrder()} />
                                                        :
                                                        <Button className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}} label={this.getBasketTotal() !== null ? this.props.t("quotes.dialog.confirm") : this.props.t("checkout.messages.confirm-training")} onClick={() => this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ? this.generateCreditCardCheckout() : this.submitOrder()} />
                                                }
                                            </div> 
                                        : null
                                    }
                                    {
                                        this.state.showPaymentData === true ?
                                            (this.props.basketProducts.length > 0 || this.props.basketTrainings.length > 0) ?
                                                this.state.showCardForm === false ?
                                                    <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                        {
                                                            /*this.props.userId === null && this.props.basketProducts.length > 0 ?
                                                                <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.open(process.env.PUBLIC_URL + "/products-public", "_self")} />
                                                                : null */
                                                        }
                                                        {
                                                          //  this.props.userId !== null ?
                                                          //      this.props.basketProducts.length > 0 ?
                                                                    <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                          //          :
                                                          //          <Button className='p-button-info' label={this.props.t("checkout.messages.continue-training")} onClick={() => window.open(process.env.PUBLIC_URL + "/trainings", "_self")} />
                                                          //  : null
                                                        }                                                        
                                                        <Button className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}} label={this.getBasketTotal() !== null ? this.props.t("quotes.dialog.confirm") : this.props.t("checkout.messages.confirm")} onClick={() => this.props.operation.selectedPaymentMethod === PAYMENT_METHOD_CC ? this.generateCreditCardCheckout() : this.submitOrder()} />
                                                    </div> 
                                                    : 
                                                    <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                        <Button className='p-button-danger' label={this.props.t("general.cancel")} onClick={() => this.setState({showCardForm: false})} />
                                                    </div> 
                                                    :                 
                                                    <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                        {
                                                            this.props.userId === null && this.props.basketProducts.length > 0 ?
                                                                <>
                                                                    <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                                    <Button disabled className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}}  label={this.props.t("checkout.messages.confirm")} onClick={() => this.submitOrder()} />
                                                                </>
                                                                : null
                                                        }
                                                        {
                                                            this.props.userId !== null && this.props.basketProducts.length > 0 ?
                                                                <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                                :
                                                                null
                                                              //  <Button className='p-button-info' label={this.props.t("checkout.messages.continue-training")} onClick={() => window.open(process.env.PUBLIC_URL + "/trainings", "_self")} />
                                                        }
                                                        {
                                                            this.props.userId !== null && this.props.basketProducts.length > 0 ?
                                                                <Button disabled className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}}  label={this.props.t("checkout.messages.confirm")} onClick={() => this.submitOrder()} />
                                                                :
                                                                <Button disabled className='p-button-success' style={{marginLeft: isMobileOnly ? null : "30px", marginTop: isMobileOnly ? "10px" : null}}  label={this.props.t("checkout.messages.confirm-training")} onClick={() => this.submitOrder()} />
                                                        }
                                                </div> 
                                            : 
                                            (this.props.basketProducts.length === 0 && this.props.basketTrainings.length === 0) ?
                                                <div className="col-12 mgt-10" style={{textAlign: isMobileOnly ? "center" : "right" }}>
                                                    <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.history.back()} />
                                                    {/*
                                                        this.props.userId === null ?
                                                            <Button className='p-button-info' label={this.props.t("checkout.messages.continue")} onClick={() => window.open(process.env.PUBLIC_URL + "/products-public", "_self")} />
                                                            :
                                                            <Button className='p-button-info' label={this.props.t("checkout.messages.continue-training")} onClick={() => window.open(process.env.PUBLIC_URL + "/trainings", "_self")} />
                                                    */}
                                                </div> 
                                                : 
                                                null
                                    }
                                    </>
                                    : null
                                }
                            </div>
                        </div>
                    }
                    </div>
                    <div className='col-2'></div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>  
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        userId: state.authentication.userId,
        associate: state.profile.associate,
        generatedPaymentRef: state.quote.generatedPaymentRef,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings,
        publicBuyer: state.store.publicBuyer,
        operation: state.store.operation
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) },
        updatePublicBuyer: (buyer) => { dispatch(updatePublicBuyer(buyer)) },
        updateGeneratedPaymentRef: (paymentRef) => { dispatch(updateGeneratedPaymentRef(paymentRef)) },
        updateOrderOperationData: (operation) => { dispatch(updateOrderOperationData(operation)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CheckoutPage));